import { costCodesStyles } from "@insite/content-library/Widgets/Budget/CostCodes";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

costCodesStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        /* &:hover {
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("text.accent")} !important;
    } */

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
       
    } */
        }
    `,
};
costCodesStyles.saveButton = {
    css: css`
        margin-left: 10px;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};
costCodesStyles.addCostCodeButton = {
    css: css`
        display: block;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        /* &:hover {
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("text.accent")} !important;
    } */

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            /* background: ${getColor("text.accent")}; */
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            opacity: 0.3;
            background: none !important;

            /* span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
       
    } */
        }
    `,
    variant: "secondary",
};
costCodesStyles.costCodesTableGridItems = {
    width: [12, 12, 12, 12, 6],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    overflow: auto;
                    white-space: nowrap;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
costCodesStyles.dataTableHeaders = {
    css: css`
        white-space: nowrap !important;
    `,
};
